function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from "prop-types";
import { useTheme } from '@pixel/core/styles';
const getListStyle = (theme, isDraggingOver, isEmpty) => {
  const nStyle = {
    minHeight: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.5),
    display: "block",
    flex: "0 1 auto"
  };
  if (isDraggingOver) {
    nStyle.background = theme.palette.pixelContrast.fades.softest;
    nStyle.boxShadow = "0px 0px 0px 2px " + theme.palette.pixelContrast.fades.soft;
  } else {
    nStyle.background = theme.palette.pixelContrast.fades.softest;
  }
  if (isEmpty) {
    nStyle.minHeight = theme.spacing(8);
  }
  return nStyle;
};
function DropContainer(props) {
  const theme = useTheme();
  const {
    children,
    dndProvided,
    dndSnapshot,
    isEmpty,
    ...restProps
  } = props;
  //console.log("dndSnapshot", dndSnapshot)
  //console.log("dndProvided", dndProvided)
  return /*#__PURE__*/React.createElement("div", _extends({}, dndProvided.droppableProps, {
    ref: dndProvided.innerRef,
    style: getListStyle(theme, dndSnapshot.isDraggingOver, isEmpty)
  }, restProps), children);
}
DropContainer.propTypes = {
  dndProvided: PropTypes.object.isRequired,
  dndSnapshot: PropTypes.object.isRequired,
  isEmpty: PropTypes.bool
};
export default DropContainer;